(function () {
  var VARS = {
    '--dropdownMenu-border': 'rgba(20, 20, 20, 0.14)',
    '--dropdownMenu-activeBorder': 'rgba(196, 114, 74, 0.75)',
    '--active-dropdown-border': 'rgba(196, 114, 74, 0.75)',
    '--list-menu-border': 'rgba(20, 20, 20, 0.14)',
    '--default-input-border': 'rgba(20, 20, 20, 0.14)',
    '--default-input-activeBorder': 'rgba(196, 114, 74, 0.75)',
    '--active-input-border': 'rgba(196, 114, 74, 0.75)',
    '--dropdown-border-radius': '0.75rem',
    '--dropdownMenu-border-radius': '0.75rem',
    '--inputs-radius': '0.75rem',
    '--quantitySelector-border': 'rgba(20, 20, 20, 0.14)',
    '--quantitySelector-activeBorder': 'rgba(196, 114, 74, 0.75)',
  };

  var ROOT =
    '.easify-product-options, [class*="easify-product-options"], [class*="easify-product"]';

  function applyVars(node) {
    if (!node || !node.style) return;
    Object.keys(VARS).forEach(function (key) {
      node.style.setProperty(key, VARS[key], 'important');
    });
  }

  function cleanWrapper(node) {
    if (!node || !node.style) return;
    node.style.setProperty('border', 'none', 'important');
    node.style.setProperty('outline', 'none', 'important');
    node.style.setProperty('box-shadow', 'none', 'important');
  }

  function unlockDropdown(wrapper) {
    if (!wrapper || !wrapper.style) return;

    wrapper.style.setProperty('position', 'relative', 'important');
    wrapper.style.setProperty('overflow', 'visible', 'important');

    var inner = wrapper.querySelector('.tpo_option-input-inner');
    if (inner) {
      inner.style.setProperty('position', 'relative', 'important');
      inner.style.setProperty('overflow', 'visible', 'important');
    }

    var trigger = wrapper.querySelector('.tpo_option-input.tpo_option-dropdown');
    if (trigger) {
      trigger.style.setProperty('pointer-events', 'auto', 'important');
      trigger.style.setProperty('cursor', 'pointer', 'important');
      trigger.style.setProperty('position', 'relative', 'important');
      trigger.style.setProperty('z-index', '2', 'important');
    }

    var menu = wrapper.querySelector('.tpo_option-type-dropdown-wrapper');
    if (menu) {
      menu.style.setProperty('position', 'absolute', 'important');
      menu.style.setProperty('z-index', '41', 'important');
      menu.style.setProperty('overflow-x', 'hidden', 'important');
      menu.style.setProperty('overflow-y', 'auto', 'important');
      menu.style.setProperty('-webkit-overflow-scrolling', 'touch', 'important');
      menu.style.setProperty('border-radius', '0.75rem', 'important');
      menu.style.setProperty('border', '1px solid rgba(20, 20, 20, 0.14)', 'important');
    }
  }

  function fixEasifyDropdowns() {
    document.querySelectorAll(ROOT).forEach(function (root) {
      applyVars(root);
      root.style.setProperty('overflow', 'visible', 'important');
      root.querySelectorAll('[data-tpo-theme], .tpo_option-set-wrapper').forEach(applyVars);
    });

    document.querySelectorAll('.tpo_option-input-wrapper, .tpo_option-label.tpo_dropdown').forEach(cleanWrapper);

    document.querySelectorAll('.tpo_option-input-inner').forEach(function (inner) {
      applyVars(inner);
      cleanWrapper(inner.parentElement);
    });

    document.querySelectorAll('.tpo_option-input-wrapper').forEach(unlockDropdown);
  }

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(fixEasifyDropdowns, 60);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
